import {ToggleButtonGroup, ToggleButtonGroupProps, ToggleButtonProps} from '@mui/material';
import {Controller, useFormContext} from 'react-hook-form';
import {ComponentWithRequiredChildElements, PropsWithRequiredChildElements} from '../react/types';

type AllowedToggleButtonGroupProps = Omit<ToggleButtonGroupProps, 'exclusive'>;
export interface SingleChoiceToggleButtonInputFieldProps extends PropsWithRequiredChildElements<
  AllowedToggleButtonGroupProps,
  ToggleButtonProps
> {
  name: string;
  required?: boolean;
}

export const SingleChoiceToggleButtonInputField: ComponentWithRequiredChildElements<
  SingleChoiceToggleButtonInputFieldProps
> = ({
  children,
  defaultValue = '',
  name,
  onBlur,
  onChange,
  required = false,
  ...muiProps
}: SingleChoiceToggleButtonInputFieldProps) => {
  const {control, trigger} = useFormContext();
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({field}) => (
        <ToggleButtonGroup
          {...muiProps}
          {...field}
          exclusive
          onBlur={(event) => {
            field.onBlur();
            if (onBlur) {
              onBlur(event);
            }
          }}
          onChange={(event, value) => {
            // Don't allow the change to be made if it violates the required constraint
            if (required && !value) {
              return;
            }
            field.onChange(value);
            void trigger(name);
            if (onChange) {
              onChange(event, value);
            }
          }}
        >
          {children}
        </ToggleButtonGroup>
      )}
    />
  );
};
